<div id="whatsapp-icon" class="whaIcon">
    <a href="https://api.whatsapp.com/send?l=es_mx&phone=525570050533" target="_blank">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/240px-WhatsApp.svg.png"
            width="50" height="50">
    </a>
</div>